<template>
    <div class="px-3 py-2">
        <v-form
            ref="formcc"
            lazy-validation
        >
        <b-sidebar backdrop id="scanQR" width="700px" aria-labelledby="sidebar-no-header-title" no-header style="direction:ltr" right :title="lang.add_task" shadow @shown="onOpen" @hidden="onClose">
            <template #default="{ hide }">
            <div class="m-1 text-start" style="direction:rtl">
                <div style="width:120px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
                <span>{{ lang.langname === 'ar' ? 'مسح رمز الاتصال' : 'Scan QR Code' }}</span>
                </div>
                <div @click="hide" id="hideAddUnit" style="text-align:center;width:100px;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm">
                <span>{{lang.close}}</span>
            </div>
            </div>
            <v-divider></v-divider>
            <v-alert v-if="loadError" type="error" dense outlined>{{ lang.whatsapp_provider_unavailable }}</v-alert>
            <v-row class="m-2 text-center" style="direction:rtl">
                <v-col cols="12" md="12" v-if="status === 'WORKING'">
                    <div style="padding:60px 10px;font-size:18px;color:#1a7d3f">
                        {{lang.connected}} — {{ phone || '' }}
                    </div>
                </v-col>
                <v-col cols="12" md="12" v-else-if="qrImage">
                    <img :src="qrImage" style="max-width:320px;width:100%;border:1px solid #ddd;border-radius:8px;padding:8px" />
                    <div style="margin-top:10px;color:#666">{{ statusLabel }}</div>
                </v-col>
                <v-col cols="12" md="12" v-else>
                    <div style="padding:60px 10px;color:#666">{{ statusLabel }}</div>
                </v-col>
            </v-row>
    </template>
            <template #footer="" class="shadow">
                <div class="d-flex text-light align-items-center px-3 py-2">
                <b-button type="button" @click="refresh()" variant="success" class="ma-2" style="width:120px;">{{ lang.refresh || 'Refresh' }}</b-button>
                </div>
            </template>
        </b-sidebar>
        </v-form>
    </div>
</template>

<script>
import axios from 'axios'
export default{
    data() {
        return {
            status: '',
            phone: '',
            qrImage: '',
            pollTimer: null,
            loadError: false,
            busy: false,
            openSerial: 0,
            isOpen: false,
        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        statusLabel: function(){
            if(this.lang.langname==='ar')return {STOPPED:'لم يبدأ الاتصال',STARTING:'جارٍ بدء الاتصال',SCAN_QR_CODE:'امسح الرمز باستخدام واتساب',WORKING:'متصل',FAILED:'فشل الاتصال، حاول مجدداً'}[this.status] || 'جارٍ التحقق';
            const map = {
                STOPPED: 'Not started',
                STARTING: 'Starting…',
                SCAN_QR_CODE: 'Scan the QR code with WhatsApp',
                WORKING: 'Connected',
                FAILED: 'Connection failed — try again',
            };
            return map[this.status] || 'Checking…';
        },
    },
    methods: {
        async post(type, extra = {}){
            const post = new FormData();
            post.append("type", type);
            post.append('defBranch', localStorage.getItem('defBranch'));
            post.append('financeYear', localStorage.getItem('financeYear'));
            post.append("auth", this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("lang", this.$cookies.get(this.$store.state.LangCooki));
            post.append("data[id]", 0);
            Object.keys(extra).forEach(k => post.append(k, extra[k]));
            const response = await axios.post(this.$store.state.SAMCOTEC.r_path, post);
            if (!response || !response.data || Number(response.data.error && response.data.error.number)!==200 || !response.data.results) throw new Error('WhatsApp request failed');
            return response && response.data ? response.data.results : null;
        },
        async fetchQR(){
            const serial=this.openSerial;
            const results = await this.post('wahaQR');
            if(!this.isOpen || serial!==this.openSerial)return;
            if(results && results.data && results.data.data){
                const mimetype = results.data.mimetype || 'image/png';
                this.qrImage = `data:${mimetype};base64,${results.data.data}`;
            }
        },
        async fetchStatus(){
            const serial=this.openSerial;
            const results = await this.post('wahaSessionStatus');
            if(!this.isOpen || serial!==this.openSerial)return;
            if(results && results.data){
                this.status = results.data.status || '';
                this.phone = (results.data.me && results.data.me.id) ? results.data.me.id.split('@')[0] : '';
            }
        },
        async refresh(){
            if(this.busy || !this.isOpen)return false;
            const serial=this.openSerial;this.busy=true;this.loadError=false;
            try {
            await this.fetchStatus();
            if(!this.isOpen || serial!==this.openSerial)return false;
            if(this.status !== 'WORKING'){
                await this.fetchQR();
            }else{
                this.qrImage = '';
            }
            return true;
            }catch(e){if(serial===this.openSerial)this.loadError=true;return false;}
            finally{if(serial===this.openSerial)this.busy=false;}
        },
        async onOpen(){
            this.onClose();this.isOpen=true;this.loadError=false;
            const serial=this.openSerial;
            try {
            await this.post('wahaStartSession');
            if(!this.isOpen || serial!==this.openSerial)return;
            await this.refresh();
            if(!this.isOpen || serial!==this.openSerial)return;
            this.pollTimer = setInterval(() => {
                if(this.status === 'WORKING'){
                    clearInterval(this.pollTimer);
                    this.pollTimer = null;
                    this.$emit('connected');
                    return;
                }
                this.refresh();
            }, 4000);
            }catch(e){if(serial===this.openSerial)this.loadError=true;}
        },
        onClose(){
            this.isOpen=false;this.openSerial++;this.busy=false;this.qrImage='';
            if(this.pollTimer){
                clearInterval(this.pollTimer);
                this.pollTimer = null;
            }
        },
    },
    beforeDestroy(){
        this.onClose();
    },
}
</script>
